export default {
  base: {
    baseUrl: process.env.VUE_APP_BASE_URL
  }
}